import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalConfigService {

  private socialMedia = {
    instagram: 'https://www.instagram.com/broadfactoroficial/',
    facebook: 'https://www.facebook.com/broadfactoroficial',
    linkedin: 'https://www.linkedin.com/company/broadfactor/',
    youtube: 'https://www.youtube.com/channel/UChxZcuH2MjPLA7ebO4VKqUA'
  }

  private contactNumber = {
    formatted: '(47) 99215-7013',
    unformatted: '47992157013',
    redirectUrl: 'https://api.whatsapp.com/send/?phone=5547992157013&text&app_absent=1'
  }

  private broadWebsite = {
    mainUrl: environment.broad_website,
    aboutUs: environment.broad_website + 'broadfactor/sobre',
  }

  private blogBroadfactor = 'https://blogbroadfactor.com/'

  private address = 'Rua Jerônimo Coelho, nº 78, CEP: 89201-050. Joinville (SC)'
  private email = 'suporte@broadfactor.com'

  private plataformUrlList = {
    loginUrl: environment.antecipa_plataforma + 'login',
    supplierRegisterUrl: environment.antecipa_plataforma + 'cadastro/fornecedor',
    buyerRegisterUrl: environment.antecipa_plataforma + 'cadastro/financiador',
    comprasNetURL: 'https://antecipagov.comprasnet.gov.br/'
  }

  private documentsAwsUrl = {
    termsOfUse: 'https://broadfactors3-public.s3.sa-east-1.amazonaws.com/Termos/cedente/Termos_+de_Uso_Broadfactor.pdf',
    privacyPolicy: 'https://broadfactors3-public.s3.sa-east-1.amazonaws.com/Termos/cedente/Pol%C3%ADtica+de+Privacidade+Broadfactor.pdf',
    credential: 'https://broadfactors3-public.s3.sa-east-1.amazonaws.com/Termos/credenciamento-broadfactor.pdf'
  }


  getSocialMedia() {
    return this.socialMedia;
  }

  getContactNumber() {
    return this.contactNumber;
  }

  getBroadWebsite() {
    return this.broadWebsite;
  }

  getBlogBroadfactor() {
    return this.blogBroadfactor;
  }

  getAddress() {
    return this.address;
  }

  getEmail() {
    return this.email;
  }

  getPlataformUrlList() {
    return this.plataformUrlList;
  }

  getDocumentsAwsUrl() {
    return this.documentsAwsUrl;
  }
}
